<template>
  <a-dialog v-model="isOpen" scrollable persistent max-width="650px">
    <v-card flat>
      <v-toolbar color="primaryLight1" dark height="50px">
        <span>{{ $t("statistics.hSetParameter") }}</span>
        <v-spacer></v-spacer>
        <CloseIcon @click="close()" />
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-form
            ref="refTimeAllocationForm"
            v-model="validDate"
            lazy-validation
            style="display: contents"
          >
            <v-col cols="12">
              <v-row no-gutters>
                <v-col cols="2" class="text-right mr-3 mt-2">
                  {{ $t("search.startDate") }}:
                </v-col>
                <v-col cols="8">
                  <v-menu
                    v-model="calmenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="dateField"
                        ref="reffromdaterange"
                        v-model="formatStartDate"
                        append-icon="mdi-calendar"
                        single-line
                        dense
                        :label="`${$t('search.startDate')} *`"
                        :placeholder="`${$t('search.startDate')} *`"
                        hide-details="auto"
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        required
                        :rules="startDateRule"
                        outlined
                        @click:append="calmenu = true"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="timeAllocationInput.startDate"
                      :locale="selectedLang"
                      color="appMenu lighten-1"
                      @input="calmenu = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row no-gutters class="py-2">
                <v-col cols="2" class="text-right mr-3 mt-2">
                  {{ $t("search.endDate") }}:
                </v-col>
                <v-col cols="8">
                  <v-menu
                    v-model="calmenu2"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="dateField"
                        ref="reffromdaterange"
                        v-model="formatEndDate"
                        append-icon="mdi-calendar"
                        single-line
                        dense
                        :label="`${$t('search.endDate')} *`"
                        :placeholder="`${$t('search.endDate')} *`"
                        hide-details="auto"
                        v-bind="attrs"
                        v-on="on"
                        readonly
                        required
                        :rules="endDateRule"
                        outlined
                        @click:append="calmenu2 = true"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="timeAllocationInput.endDate"
                      :min="timeAllocationInput.startDate"
                      :locale="selectedLang"
                      color="appMenu lighten-1"
                      @input="calmenu2 = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12">
              <v-row no-gutters class="">
                <v-col cols="2" class="text-right mr-3 mt-2">
                  {{ $t("agenda.lblMeetingType") }}:
                </v-col>
                <v-col cols="8">
                  <v-select
                    class="selectField"
                    v-model="timeAllocationInput.meetingType"
                    :items="meetingTypesList"
                    :label="$t('agenda.lblMeetingType')"
                    :placeholder="$t('agenda.lblMeetingType')"
                    single-line
                    dense
                    multiple
                    :menu-props="{ bottom: true, offsetY: true }"
                    item-text="label"
                    item-value="id"
                    return-object
                    @focus="focusSelect"
                    ref="refMeetingType"
                    id="meetingType"
                    outlined
                    :no-data-text="noMeetingTypeMsg"
                  >
                    <template v-slot:selection="data">
                      <a-chip
                        v-bind="data.attrs"
                        outlined
                        class="my-1"
                        label
                        small
                        :input-value="data.selected"
                        color="secondary darken-3"
                        close
                        dark
                        @click:close="remove(data.item)"
                        >{{ data.item.label }}</a-chip
                      >
                    </template>
                  </v-select>
                </v-col>
              </v-row>
            </v-col>
          </v-form>
        </v-row>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              class="mr-2 primaryDark"
              @click="onFilter()"
              >{{ $t("btnOk") }}</a-btn
            >
          </template>
          <span>{{ $t("btnOk") }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <a-btn
              v-bind="attrs"
              v-on="on"
              class="secondary"
              @click="close()"
              >{{ $t("btnLabelCancel") }}</a-btn
            >
          </template>
          <span>{{ $t("btnLabelCancel") }}</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </a-dialog>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import { formatDate } from "@/utils/util";
Vue.use(DatePickerPlugin);
export default {
  name: "FilterDialog",
  data() {
    return {
      noMeetingTypeMsg: this.$t("noData"),
      calmenu: false,
      calmenu2: false,
      validDate: true,
      comboboxAutoSuggest: "none",
      resultSearch: null,
      meetingObject: this.selectedMeeting,
      timeAllocationInput: {
        meetingType: [],
        startDate: new Date().toISOString().slice(0, 10),
        endDate: new Date().toISOString().slice(0, 10),
        selectedEmail: [],
      },
      isValidEndDate: false,
      startDateRule: [(v) => !!v || this.$t("lblSelectDate")],
      endDateRule: [(v) => !!v || this.$t("lblSelectDate")],
      filterPayload: null,
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    hasCalledFromStatistics: {
      type: Boolean,
      default: false,
    },
  },
  async mounted() {
    const comboElem = document.getElementById("searchComboBox");
    if (comboElem) {
      comboElem.setAttribute("autocomplete", "none");
    }
    let timeAllocationInput = sessionStorage.getItem(
      "timeAllocationFilterInputs"
    );
    timeAllocationInput = JSON.parse(timeAllocationInput);
    if (timeAllocationInput && !this.hasCalledFromStatistics) {
      this.timeAllocationInput.startDate = timeAllocationInput?.start_date;
      this.timeAllocationInput.endDate = timeAllocationInput?.end_date;
      this.timeAllocationInput.meetingType = timeAllocationInput?.meeting_type;
    }
  },
  methods: {
    ...mapActions({
      getStatisticsData: "admin/getStatisticsData",
      getCustomMeetingList: "meeting/getCustomMeetingList",
    }),
    formatDate,
    remove(item) {
      const index = this.timeAllocationInput.meetingType
        .map((e) => e.id)
        .indexOf(item.id);
      if (index >= 0) this.timeAllocationInput.meetingType.splice(index, 1);
    },
    close() {
      this.$refs.refTimeAllocationForm.resetValidation();
      this.isOpen = false;
    },
    async onFilter() {
      if (this.$refs.refTimeAllocationForm.validate()) {
        const formData = {
          filter_type: "custom",
          start_date: this.timeAllocationInput.startDate,
          end_date: this.timeAllocationInput.endDate,
        };
        await this.getCustomMeetingList(formData)
          .then((res) => {
            formData.meeting_type = !this.timeAllocationInput.meetingType.length
              ? this.meetingTypesList
              : this.timeAllocationInput.meetingType;

            sessionStorage.setItem(
              "timeAllocationFilterInputs",
              JSON.stringify(formData)
            );
            this.$emit("timeAllocationPayload", formData);
            if (this.$route.path !== "/statistics&analysis/timeanalysis") {
              this.$router.push({ path: "/statistics&analysis/timeanalysis" });
            } else {
              this.close();
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    focusSelect(e) {
      this.scrolling(e.srcElement);
    },
    scrolling(element) {
      let dialogCardEl = document.getElementById("dialog-card-text");
      if (dialogCardEl) {
        dialogCardEl.addEventListener("scroll", (event) => {
          if (element && element.id == "meetingType") {
            if (this.$refs.refMeetingType.$refs.input) {
              this.$refs.refMeetingType.blur();
            }
          } else if (element && element.id == "resType") {
            if (this.$refs.refResType.$refs.input) {
              this.$refs.refResType.blur();
            }
          }
        });
      }
    },
    filter(item, queryText) {
      const hasValue = (val) => (val != null ? val : "");
      const query = hasValue(queryText);
      return (
        (item.firstName &&
          item.firstName
            .toLowerCase()
            .indexOf(query.toString().toLowerCase()) !== -1) ||
        (item.lastName &&
          item.lastName
            .toLowerCase()
            .indexOf(query.toString().toLowerCase()) !== -1) ||
        (item.contactEmailIds &&
          item.contactEmailIds.filter(
            (email) =>
              email &&
              email.toLowerCase().indexOf(query.toString().toLowerCase()) !== -1
          ).length > 0)
      );
    },
  },
  watch: {
    "timeAllocationInput.startDate": {
      immediate: true,
      handler(date) {
        if (
          date > this.timeAllocationInput.endDate &&
          this.timeAllocationInput.endDate != ""
        ) {
          this.timeAllocationInput.endDate = date;
        }
      },
    },
    "timeAllocationInput.endDate": {
      immediate: true,
      handler(endDate) {
        if (endDate === null || this.timeAllocationInput.endDate == "") {
          this.isValidEndDate = true;
        } else this.isValidEndDate = false;
      },
    },
  },
  computed: {
    ...gettersMap(),
    ...mapState({}),
    dateFormat() {
      return this.selectedLang !== "ja" ? "dd-MM-yyyy" : "yyyy-MM-dd";
    },
    formatStartDate: {
      get() {
        return this.formatDate(
          new Date(this.timeAllocationInput.startDate),
          this.dateFormat
        );
      },
      set(value) {
        this.$emit("input", value || "");
      },
    },
    formatEndDate: {
      get() {
        return this.formatDate(
          new Date(this.timeAllocationInput.endDate),
          this.dateFormat
        );
      },
      set(value) {
        this.$emit("input", value || "");
      },
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    isOpen: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    loaderText() {
      return this.$t("LoaderText");
    },
    currentDate() {
      return new Date().toISOString().slice(0, 10);
    },
    meetingTypesList() {
      let list = [];
      if (this.meetingTypes && this.meetingTypes.length > 0) {
        list = this.meetingTypes.filter((item) =>
          this.$security.checkMeetingTypeAccess(item.id, "CreateMeeting")
        );
        this.noMeetingTypeMsg = !list.length
          ? this.$t("noMeetingTypeData")
          : "";
        return list;
      } else {
        this.noMeetingTypeMsg = this.$t("noData");
      }
    },
  },
};
function gettersMap() {
  return mapGetters({
    meetingTypes: "tenant/agendaMeetingTypes",
  });
}
</script>

<style scoped>
.searchComboBox /deep/ .v-input__control > .v-input__slot {
  color: var(--v-neutralGray-base) !important;
}
.v-list-item:has(.combo-list) {
  margin: 0px !important;
  padding: 0px !important;
}
.combo-list {
  width: 100%;
}
.combo-list .v-list-item {
  width: 100%;
  cursor: pointer;
}
.combo-list .v-list-item:hover {
  background-color: #e6e6e6 !important;
}
.combo-list .v-list-item.selected {
  background-color: paleturquoise !important;
}
.combo-list .v-list-item label {
  cursor: pointer;
}
::v-deep .e-date-wrapper {
  border: 1px solid gray !important;
  border-radius: 4px !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
  height: 40px;
  font-size: 15px !important;
}

::v-deep .e-date-wrapper .e-input-group-icon {
  min-height: 18px !important;
  min-width: 18px !important;
}
.selectField /deep/ .v-label {
  line-height: 19px !important;
}
.selectField /deep/ .v-select__selections {
  line-height: 21px !important;
  max-height: 100px !important;
}
.selectField /deep/ .v-input__control,
.selectField /deep/ .v-input__slot {
  max-height: 110px !important;
}
.selectField /deep/ .v-select__slot {
  max-height: 110px !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
}
.selectField /deep/ .v-input__slot {
  padding: 0 0 0 12px !important;
}
</style>